import Skeleton from '@mui/material/Skeleton';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { JsonCopyToClipboardField } from 'shared/react-admin/Fields';
import { MerchantAccount } from 'types/embedded/merchantAccount';

import { useMerchantAccountCredentials } from './hooks/useMerchantAccountCredentials';

type AccountsCredentialsDialogProps = {
  open: boolean;
  onClose: () => void;
  actions?: React.ReactNode;
  record?: Partial<MerchantAccount>;
};

export const AccountsCredentialsDialog: React.FC<AccountsCredentialsDialogProps> = ({
  open,
  onClose,
  record,
  actions,
}) => {
  const translate = useTypedTranslate();
  const { credentials, isLoading } = useMerchantAccountCredentials(record?.originId, open);

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title={translate('app.merchantAccounts.accountAccessWithParams')}
        titleSize="smallBold"
      />
      <RecordContextProvider value={{ credentials }}>
        <CardContent>
          {isLoading ? (
            <Skeleton height={103} variant="rounded" width="100%" />
          ) : (
            <JsonCopyToClipboardField label="Доступ к счету {json}" source="credentials" />
          )}
        </CardContent>
      </RecordContextProvider>
      {actions}
    </Dialog>
  );
};
